
import { httpGet } from "../Web";
import { ApiResponse } from "./ApiResponse";
import { WorkshopInterface } from "./WorkshopInterface";
import { WorkshopUser } from "./WorkshopUser";

export interface Workshop {
    id: number,
    name: string,
    startDate: string,
    endDate: string,
    location: string,
    contactEmail: string,
    informationUrl: string | undefined,
    status: number,
    fee: string,
    paymentType: PaymentType,
    maxUsers: number,
    guid: string
};

export interface WorkshopInterfaceStatistics {
    id: number;
    interfaceName: string;
    possibleTestCases: number;
    totalTestcases: number;
    executedTestcases: number;
    failedTestcases: number;
}

export interface WorkshopStatistics {
    registeredUsers: number;
    registeredCompanies: number;
    registeredProducts: number;
    validCombinations: number;
    availableInterfaces: number;
    interfacesUsed: number;
    possibleTestCases: number;
    totalTestcases: number;
    executedTestcases: number;
    failedTestcases: number;
    interfaceStatistics: WorkshopInterfaceStatistics[];
}

export enum PaymentType { Free = 0, CreditCard = 1 };
export const PaymentTypeStrings = ["Free", "Credit Card"];
export enum WorkshopStatus {
    Created = 0, PreRegistration = 1, Registration = 2, Testing = 3, Closed = 4, Invisible = 5
}

export const WorkshopStatusStrings = ["Created", "Pre-Registration", "Registration", "Testing", "Closed", "Invisible"];

export const getWorkshop = (id: number, abortController: AbortController): Promise<ApiResponse<Workshop>> => httpGet(`/api/workshop/get/${id}`, abortController);
export const getUpcomingWorkshop = (abortController: AbortController): Promise<ApiResponse<Workshop>> => httpGet(`/api/workshop/getUpcoming/`, abortController);
export const getActiveUserWorkshops = (abortController: AbortController): Promise<ApiResponse<Workshop[]>> => httpGet(`/api/workshop/activeUserWorkshops/`, abortController);
export const getCurrentWSUser = (id: number, abortController: AbortController): Promise<ApiResponse<WorkshopUser>> => httpGet(`/api/workshop/user/getCurrentUser/${id}`, abortController);
export const getWorkshops = (abortController: AbortController): Promise<ApiResponse<Workshop[]>> => httpGet('/api/workshop/', abortController);

export const getWorkshopStatistics = (id: number, abortController: AbortController): Promise<ApiResponse<WorkshopStatistics>> => httpGet(`/api/workshop/statistics/${id}`, abortController);

export const getWorkshopInterfaces = (id: number, abortController: AbortController): Promise<ApiResponse<WorkshopInterface[]>> =>
    httpGet(`/api/workshop/interface/${id}`, abortController);